
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenWeatherCounty } from './GenWeatherCounty';

export class GenWeatherCountyResponse {

    category: string;
    count: number;
    datasetVersion: string;
    items: GenWeatherCounty[];
    studyPeriod: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherCountyResponse: GenWeatherCountyResponse);

    constructor( input?: GenWeatherCountyResponse ) {
        if ( input && typeof input !== 'number' ) {
            this.category = input.category; // string [string]
            this.count = input.count; // int [number]
            this.datasetVersion = input.datasetVersion; // string [string]
            if ( input.items && input.items.map ) { // list [GenWeatherCounty]
                this.items = input.items.map( ( x: GenWeatherCounty ) => {
                    return new GenWeatherCounty( x );
                } );
            } else {
                this.items = input.items;
            }
            this.studyPeriod = input.studyPeriod; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherCountyResponse[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherCountyResponse(a));
        } else {
          return [];
        }
    }
}

